import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  QueryDefinition,
  QueryActionCreatorResult,
} from '@reduxjs/toolkit/query';

import { RTKQueryTag } from 'src/common/constants';
import { ApiResponse, PaginatedResponse } from 'src/common/interfaces';
import { PublicProfileParams, PublicProfileRoom } from 'src/common/interfaces/public-profile';

export enum PublicProfileTabPanelValue {
  COMPLETED_ROOMS = 'Completed rooms',
  CREATED_ROOMS = 'Created rooms',
  YEARLY_ACTIVITY = 'Yearly activity',
  TICKETS = 'Tickets',
  BADGES = 'Badges',
  CERTIFICATES = 'Certificates',
  SKILLS_MATRIX = 'Skills matrix',
}

export type PublicProfileTab = {
  value: PublicProfileTabPanelValue;
  text: string;
  icon: IconDefinition;
};

export type UseGetRoomsResponse = {
  rooms: PublicProfileRoom[] | undefined;
  isLoading: boolean;
  refetch: () => QueryActionCreatorResult<
    QueryDefinition<
      PublicProfileParams,
      BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
      RTKQueryTag,
      ApiResponse<PaginatedResponse<PublicProfileRoom>>,
      'api'
    >
  >;
  totalRooms: number | undefined;
  totalPages: number | undefined;
};

export interface UsePublicProfileTabsProps {
  loggedInUserId?: string;
  publicProfileUserId?: string;
}
